import React from 'react';
import PropTypes from 'prop-types';
import GOOGLE_MAP_ENUMS from '../../../shared/engage/engage-google-map-enums';

const shapeTypes = GOOGLE_MAP_ENUMS().shapeTypes;

// Inline SVG glyphs for the map draw-tool bar. Terra Draw ships no UI, and the old google.maps
// DrawingManager's icon control was removed along with the library (#2509). These are kept
// self-contained (no shared icon sprite) so the map bar owns its own look; fill/stroke inherit the
// button's currentColor. Each <button> is icon-only, so the label is exposed via title + aria-label
// (the svg itself is decorative / aria-hidden).
const ICONS = {
  [shapeTypes.CIRCLE]: <circle cx='12' cy='12' r='8' fill='none' stroke='currentColor' strokeWidth='2' />,
  [shapeTypes.RECTANGLE]: (
    <rect x='4' y='6' width='16' height='12' rx='1' fill='none' stroke='currentColor' strokeWidth='2' />
  ),
  // Concave on purpose: the vertex at (12,11) is pulled inward so one interior angle is reflex
  // (> 180°), denting the right side. That single dent is what instantly reads as "arbitrary
  // polygon" rather than a regular shape — matching the old DrawingManager glyph. Vertex dots echo
  // its editable-handle look.
  [shapeTypes.POLYGON]: (
    <>
      <path
        d='M10 4 L18 7 L12 11 L19 16 L9 20 L4 9 Z'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinejoin='round'
      />
      <circle cx='10' cy='4' r='1.7' fill='currentColor' />
      <circle cx='18' cy='7' r='1.7' fill='currentColor' />
      <circle cx='12' cy='11' r='1.7' fill='currentColor' />
      <circle cx='19' cy='16' r='1.7' fill='currentColor' />
      <circle cx='9' cy='20' r='1.7' fill='currentColor' />
      <circle cx='4' cy='9' r='1.7' fill='currentColor' />
    </>
  ),
  [shapeTypes.MARKER]: (
    <>
      <path d='M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7z' fill='currentColor' />
      <circle cx='12' cy='9' r='2.5' fill='#fff' />
    </>
  ),
};

function DrawToolButton({ tool, label, onSelect }) {
  return (
    <button
      type='button'
      className='o-button o-button--secondary o-map__draw-tool'
      title={label}
      aria-label={label}
      onClick={() => onSelect(tool)}
    >
      <svg width='20' height='20' viewBox='0 0 24 24' aria-hidden='true' style={{ display: 'block' }}>
        {ICONS[tool]}
      </svg>
    </button>
  );
}

DrawToolButton.propTypes = {
  tool: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default DrawToolButton;
